export default "/_next/static/images/team-bg@2x-406fd9d200da7bdf1409b7f271a64f37.png";